<ng-template #dgrBlockUi>
    <p-button
        [pTooltip]="
            !checkIfCanSave()
                ? ('discount-group.save-discount-group-first' | translate)
                : ('discount-group.missing-data-for-save' | translate)
        "
        [loading]="isSaving()"
        icon="fa fa-save"
        [label]="'discount-group.save-discount-group-first' | translate"
        [disabled]="checkIfCanSave()"
        (onClick)="saveToUnlockEditMode()"
    ></p-button>
</ng-template>

<blockable-div
    #dgrBlock
    [class]="'w-full'"
    [blocked]="isBlocked"
    [blockUi]="dgrBlockUi"
>
    @if (discountGroupId; as groupId) {
        <p-tabs scrollable [value]="0">
            <p-tablist>
                <p-tab [value]="0">{{ 'discount-group.customer' | translate }}</p-tab>
                <p-tab [value]="1">{{ 'discount-group.customer-group' | translate }}</p-tab>
                <p-tab [value]="2">{{ 'discount-group.vendor' | translate }}</p-tab>
                <p-tab [value]="3">{{ 'discount-group.vendor-group' | translate }}</p-tab>
                <p-tab [value]="4">{{ 'discount-group.document' | translate }}</p-tab>
            </p-tablist>
            <p-tabpanels>
                <p-tabpanel [value]="0">
                    <app-discount-group-customer-relation-widget
                        [discountGroupId]="groupId"
                    />
                </p-tabpanel>
                <p-tabpanel [value]="1">
                    <app-discount-group-customer-group-relation-widget
                        [discountGroupId]="groupId"
                    />
                </p-tabpanel>
                <p-tabpanel [value]="2">
                    <app-discount-group-vendor-relation-widget [discountGroupId]="groupId" />
                </p-tabpanel>
                <p-tabpanel [value]="3">
                    <app-discount-group-vendor-group-relation-widget
                        [discountGroupId]="groupId"
                    />
                </p-tabpanel>
                <p-tabpanel [value]="4">
                    <app-discount-group-document-relation-widget
                        [discountGroupId]="groupId"
                    />
                </p-tabpanel>
            </p-tabpanels>
        </p-tabs>
    }
</blockable-div>
